
import serviceClient from './serviceClient';


const checkFeatureFlag = async function checkFeatureFlag(id) {
  
  //get tenant login settting to see if we can determine tenant from host
  try {

    let storedFeatureFlags = sessionStorage.getItem('featureFlags');
    let flags;
    let flagActive = false;
    if (storedFeatureFlags) {
        flags = JSON.parse(storedFeatureFlags)
    } else {
        const settingsClient = await serviceClient.getClient('settings');
        const result = await settingsClient.apis.utilities.listFeatureFlags();
        sessionStorage.setItem('featureFlags', result.data);
        flags = result.obj;
    }
    if (flags) {
       
        const matchingFlag = flags.find(f => f.id === id);
        if (matchingFlag) {
            flagActive = matchingFlag.active;
        }
    }
    return flagActive;
    

  } catch(err) {
    console.error(err);
    console.error('Unable to get feature flags');
    return false;
  }

}
const storeFeatureFlagsInSessionStorage = async function checkFeatureFlag() {
  
  //get tenant login settting to see if we can determine tenant from host
  try {

    
        const settingsClient = await serviceClient.getClient('settings');
        const result = await settingsClient.apis.utilities.listFeatureFlags();
        sessionStorage.setItem('featureFlags', result.data);
      
    

  } catch(err) {
    console.error(err);
    console.error('Unable to get feature flags');
    
  }

}

const checkFeatureFlagInSessionStorage = (id) => {
  const featureFlagsStr = sessionStorage.getItem('featureFlags');
  if (!featureFlagsStr) return false;
  try {
    const featureFlagsJson = JSON.parse(featureFlagsStr);
    const flag = featureFlagsJson.find(flag => flag.id === id);
    if (!flag) return false;
    return flag.active === true;
  } catch (e) {
    console.error(e);
    console.error('Unable to get feature flags');
    return false;
  }
}

const makeNavGuardFeatureFlag = (featureFlag) => async (to, from, next) => {
  // next must be called exactly once
  let ffValue;
  
  try {
    ffValue = await checkFeatureFlag(featureFlag);
  } catch (e) {
    console.error('makeNavGuardFeatureFlag', e);
    next(false);
    return;
  }

  if (!ffValue) {
    next(false);
    return;
  }

  next();
  return;
}

const aiBoxQuestionTypeEnabled = async () => {
  return await checkFeatureFlag("enableAIBoxQuestionType");
}

export default {checkFeatureFlag, checkFeatureFlagInSessionStorage, storeFeatureFlagsInSessionStorage, makeNavGuardFeatureFlag, aiBoxQuestionTypeEnabled};
